const initState = {
  orderActions: { orders: [] },
  productActions: {
    update: { loading: false, success: false, error: null },
    delete: { loading: false, success: false, error: null },
    create: { loading: false, success: false, error: null },
  },
  sectionActions: {
    update: { loading: false, success: false, error: null },
    delete: { loading: false, success: false, error: null },
    create: { loading: false, success: false, error: null },
  },
};

const RestaurantReducer = (state = initState, action) => {
  switch (action.type) {
    case "START_DRIVER_UPDATE":
      return {
        ...state,
        driverActions: { loading: true, success: false, error: null },
      };
    case "DRIVER_UPDATE_SUCCESS":
      return {
        ...state,
        driverActions: { loading: false, success: true, error: null },
      };
    case "DRIVER_UPDATE_ERROR":
      return {
        ...state,
        driverActions: { loading: false, success: false, error: action.error },
      };
    case "START_RESTAURANT_UPDATE":
      return {
        ...state,
        restaurantActions: { loading: true, success: false, error: null },
      };
    case "RESTAURANT_UPDATE_SUCCESS":
      return {
        ...state,
        restaurantActions: { loading: false, success: true, error: null },
      };
    case "RESTAURANT_UPDATE_ERROR":
      return {
        ...state,
        restaurantActions: {
          loading: false,
          success: false,
          error: action.error,
        },
      };
    case "START_REPORT_GEN":
      return {
        ...state,
        reportActions: { loading: true, success: false, error: null },
      };
    case "REPORT_GEN_SUCCESS":
      return {
        ...state,
        reportActions: {
          loading: false,
          success: true,
          error: null,
          orders: action.orders,
        },
      };
    case "REPORT_GEN_ERROR":
      return {
        ...state,
        reportActions: {
          loading: false,
          success: false,
          error: action.error,
        },
      };
    case "RESET_PRODUCT_UPDATE":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          update: { loading: false, success: false, error: null },
        },
      };
    case "START_PRODUCT_UPDATE":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          update: { loading: true, success: false, error: null },
        },
      };
    case "PRODUCT_UPDATE_SUCCESS":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          update: { loading: false, success: true, error: null },
        },
      };
    case "PRODUCT_UPDATE_ERROR":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          update: { loading: false, success: false, error: action.error },
        },
      };
    case "RESET_PRODUCT_CREATE":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          create: { loading: false, success: false, error: null },
        },
      };
    case "START_PRODUCT_CREATE":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          create: { loading: true, success: false, error: null },
        },
      };
    case "PRODUCT_CREATE_SUCCESS":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          create: { loading: false, success: true, error: null },
        },
      };
    case "PRODUCT_CREATE_ERROR":
      return {
        ...state,
        productActions: {
          ...state.productActions,

          create: { loading: false, success: false, error: action.error },
        },
      };
    case "RESET_PRODUCT_DELETE":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          delete: { loading: false, success: false, error: null },
        },
      };
    case "START_PRODUCT_DELETE":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          delete: { loading: true, success: false, error: null },
        },
      };
    case "PRODUCT_DELETE_SUCCESS":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          delete: { loading: false, success: true, error: null },
        },
      };
    case "PRODUCT_DELETE_ERROR":
      return {
        ...state,
        productActions: {
          ...state.productActions,
          delete: { loading: false, success: false, error: action.error },
        },
      };
    case "RESET_SECTION_UPDATE":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          update: { loading: false, success: false, error: null },
        },
      };
    case "START_SECTION_UPDATE":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          update: { loading: true, success: false, error: null },
        },
      };
    case "SECTION_UPDATE_SUCCESS":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          update: { loading: false, success: true, error: null },
        },
      };
    case "SECTION_UPDATE_ERROR":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          update: { loading: false, success: false, error: action.error },
        },
      };
    case "RESET_SECTION_CREATE":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          create: { loading: false, success: false, error: null },
        },
      };
    case "START_SECTION_CREATE":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          create: { loading: true, success: false, error: null },
        },
      };
    case "SECTION_CREATE_SUCCESS":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          create: { loading: false, success: true, error: null },
        },
      };
    case "SECTION_CREATE_ERROR":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          create: { loading: false, success: false, error: action.error },
        },
      };
    case "RESET_SECTION_DELETE":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          delete: { loading: false, success: false, error: null },
        },
      };
    case "START_SECTION_DELETE":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          delete: { loading: true, success: false, error: null },
        },
      };
    case "SECTION_DELETE_SUCCESS":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          delete: { loading: false, success: true, error: null },
        },
      };
    case "SECTION_DELETE_ERROR":
      return {
        ...state,
        sectionActions: {
          ...state.sectionActions,
          delete: { loading: false, success: false, error: action.error },
        },
      };
    default:
      return state;
  }
};

export default RestaurantReducer;
